import React, { useEffect, useState } from 'react'

import { useMutation, useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'

import { showCompanies, updateCompanies } from '../../../../MyApi/hr/companies'

import PageHeader from '../../../../Components/UI/PageHeader'


import EditCompanies from '../../../../Components/sb/companies/companiesUpdate/AddCompanies'
import LoadingSpinner from '../../../../Components/UI/spinner'


const CompaniesUpdate = () => {
const {id} =useParams()
const [selectedCodeLang ,setSelectedCodeLang] =useState("") 
const companyshowQuery = useQuery(["showCompany" ,id ,selectedCodeLang] , ()=> showCompanies(id ,selectedCodeLang) )
const companies = companyshowQuery.data?.data || {}
const [companyName ,setComapnyName]= useState(companies.name)
const [address ,setAddress] =useState(companies.address?companies.address:null)
const [states ,setStates]=useState(companies.states ?companies.states :null)
const [slug , setSlug] =useState(companies.slug)
const [website ,setWebsite]= useState(companies.website)
const [email,setEmail] =useState(companies.email)
const [mobile ,setMobile]=useState(companies.mobile)
const [comapnyFiledId , setCompanyFiledId]= useState(companies.field_id)
const [currencyId,setCurrencyId]=useState(companies.currency_id)
const [countryId ,setCountryId]= useState(companies.country_id)
const [active,setActive] =useState(companies.active)


useEffect(()=>{
    companyshowQuery.refetch()
},[selectedCodeLang])

useEffect(() => {
    if (companyshowQuery.isSuccess) {
      setComapnyName(companies.name || "");
      setAddress(companies.address || "");
      setStates(companies.states || "");
      setSlug(companies.slug || "");
      setWebsite(companies.website || "");
      setEmail(companies.email || "");
      setMobile(companies.mobile || "");
      setCompanyFiledId(companies.field_id || "");
      setCurrencyId(companies.currency_id || "");
      setCountryId(companies.country_id || "");
      setActive(companies.active || false);
    }
  }, [companyshowQuery.data]);
 const mutation = useMutation(["UpdateComapnies" ,id ,selectedCodeLang] , (postData)=>updateCompanies(postData ,id ,selectedCodeLang) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
      
    },
    onError :(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })

 const handlePostRequest =()=>{
    mutation.mutate({
        name:companyName,     
        sb_country_id:countryId,
        address,
        states,
        slug,
        website,
        email,
        mobile,
        active,
        comapnyFiledId,
        currencyId,
        sb_country_id:+countryId,
        sb_company_field_id:+comapnyFiledId,
        sb_currency_id : +currencyId,
        lang_code:selectedCodeLang
    })
 }
 const isDisabled= ()=>{
    return false
 }
 const onSelectChange =(e)=>{
  const {value}= e.target;
  setSelectedCodeLang(value)
 } 
 if(companyshowQuery.isLoading){
    return <LoadingSpinner/>
 }
 if(!companyshowQuery.data){
    return <div> no data available</div>
 }

  return ( 

    <div>
        <PageHeader title="Update company" showSelect showBack onSelectChange={onSelectChange} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <EditCompanies selectedCodeLang={selectedCodeLang} countryId={countryId} currencyId={currencyId} comapnyFiledId={comapnyFiledId}   setActive={setActive} active={active} address={address}  companyName={companyName}    states={states} slug={slug} website={website} email={email} mobile={mobile}  setComapnyName={setComapnyName}  setAddress={setAddress} setStates={setStates} setSlug={setSlug} setWebsite={setWebsite} setEmail={setEmail} setMobile={setMobile} setCompanyFiledId={setCompanyFiledId} setCountryId={setCountryId}  setCurrencyId={setCurrencyId}/>
    </div>
  )
}  

export default CompaniesUpdate